import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {Field, reduxForm} from 'redux-form';

import Label from 'components/Label';
import Warning from 'components/Warning';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import {RadioField, DateField} from 'components/Fields';

import {DATE_FORMAT_API, DATE_FORMAT, formatDateForApi} from 'utils/datetime';
import {validDate} from 'utils/validators';
import {
  getSelectedInvoicesForPaymentInitiation,
  bulkInitiateGoCardlessPayments
} from 'ducks/reporting';

import './styles.css';

const SPECIFY_PAYMENT_DATE = 'specifyDesiredPaymentDate';
const TAKE_PAYMENT_ON_EARLIEST_CHARGE_DATE = 'takePaymentAtEarliestChargeDate';

const formSubmit = (values, dispatch, props) => {
  const {paymentMethod, paymentDate} = values;
  const {invoicesToPreview} = props;

  const data = {
    invoicesIds: invoicesToPreview.map(inv => inv.id),
    specifiedDesiredPaymentDate: paymentDate && formatDateForApi(paymentDate),
    takePaymentAtEarliestChargeDate: paymentMethod
      ? paymentMethod === TAKE_PAYMENT_ON_EARLIEST_CHARGE_DATE
      : null
  };

  const extraActions = props.getExtraActions();

  props.openConfirmationModal({
    heading: 'Initiate GoCardless Charges',
    confirmButtonText: 'Yes, initiate Charges',
    cancelButtonText: 'Cancel',
    danger: true,
    question: 'Are you sure you want to initiate GoCardless charges?',
    confirmAction: () =>
      dispatch(bulkInitiateGoCardlessPayments(data, extraActions))
  });
};

class PaymentForm extends React.Component<any> {
  state = {
    showDueDatesAfterSelectedDateWarning: false,
    showEarliestChargeDateAfterSelectedDateWarning: false,
    paymentMethod: null
  };
  resetPaymentDate = () => {
    this.props.resetSection('paymentDate');
  };

  showGCPaymentWarnings = date => {
    const {invoicesToPreview} = this.props;

    const invoicesWithDueDateAfterSelectedDate = invoicesToPreview.filter(inv =>
      moment(inv.dueDate, DATE_FORMAT_API).isAfter(moment(date, DATE_FORMAT))
    );

    const invoicesWithEarliestChargeDateAfterSelectedDate = invoicesToPreview.filter(
      inv =>
        moment(inv.earliestChargeDate, DATE_FORMAT_API).isAfter(
          moment(date, DATE_FORMAT)
        )
    );

    this.setState({
      showDueDatesAfterSelectedDateWarning:
        invoicesWithDueDateAfterSelectedDate.length > 0,
      showEarliestChargeDateAfterSelectedDateWarning:
        invoicesWithEarliestChargeDateAfterSelectedDate.length > 0
    });
  };

  onPaymentMethodChange = event => {
    this.setState({paymentMethod: event.target.value}, () =>
      this.resetPaymentDate()
    );
  };

  render() {
    const {
      showDueDatesAfterSelectedDateWarning,
      showEarliestChargeDateAfterSelectedDateWarning,
      paymentMethod
    } = this.state;
    const {invoicesToPreview, error} = this.props;
    const useEarliestChargeDate =
      paymentMethod === TAKE_PAYMENT_ON_EARLIEST_CHARGE_DATE;
    2;
    const specifyPaymentDate = paymentMethod === SPECIFY_PAYMENT_DATE;

    const dueDateAfterEarliestChargeDate =
      invoicesToPreview &&
      invoicesToPreview.filter(inv =>
        moment(inv.dueDate, DATE_FORMAT_API).isAfter(
          moment(inv.earliestChargeDate, DATE_FORMAT_API)
        )
      ).length > 0;

    return (
      <div className="PaymentForm">
        <div className="heading">Payment Date</div>

        <div className="errorContainer">
          {error && <ErrorBlock>{error}</ErrorBlock>}
        </div>

        <div className="formContainer">
          <div className="paymentBox">
            <form>
              <FormField>
                <Field
                  name="paymentMethod"
                  component={RadioField}
                  checked={useEarliestChargeDate}
                  optionValue={TAKE_PAYMENT_ON_EARLIEST_CHARGE_DATE}
                  onChange={this.onPaymentMethodChange}
                />
                <Label>Take payment at earliest charge date</Label>
              </FormField>
              <FormField className={classNames({specifyPaymentDate})}>
                <Field
                  name="paymentMethod"
                  component={RadioField}
                  checked={specifyPaymentDate}
                  optionValue={SPECIFY_PAYMENT_DATE}
                  onChange={this.onPaymentMethodChange}
                />
                <Label>Specify desired payment date</Label>
              </FormField>
              {specifyPaymentDate && (
                <FormField className="specifyChargeDate">
                  <Field
                    name="paymentDate"
                    validate={[validDate]}
                    component={DateField}
                    onDateChange={this.showGCPaymentWarnings}
                  />
                </FormField>
              )}
            </form>
          </div>
        </div>
        <div className="warnings">
          {dueDateAfterEarliestChargeDate && (
            <Warning>
              One or more invoices have due dates after the earliest charge
              date.
            </Warning>
          )}

          {showDueDatesAfterSelectedDateWarning && (
            <Warning>
              One or more invoices have due dates after the selected charge
              date.
            </Warning>
          )}

          {showEarliestChargeDateAfterSelectedDateWarning && (
            <Warning>
              One or more invoices have earliest charge dates after the
              specified payment date
            </Warning>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    selectedInvoices: getSelectedInvoicesForPaymentInitiation(state),
    initialValues: {
      paymentMethod: TAKE_PAYMENT_ON_EARLIEST_CHARGE_DATE
    }
  };
};

const bulkInitiateGoCardlessPaymentsForm = reduxForm({
  form: 'bulkInitiateGoCardlessPaymentsForm',
  onSubmit: formSubmit,
  enableReinitialize: true
})(PaymentForm);

export default connect(mapStateToProps)(
  bulkInitiateGoCardlessPaymentsForm as React.ComponentType<any>
);
